import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import {
  Component,
  OnInit,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { OnDestroy } from "@angular/core";

import { Subject } from "rxjs";
import { Subscription } from "rxjs";

import { quoteType } from "../quote-form/quote-type.const";
import { QuoteRepository } from "../quote.repository";
import { QuoteTerms } from "./quote-terms.model";
import { Quote } from "../quote.type";
import { FclTariff } from "../models/quote-fcl-tariff.model";
import { eventType } from "../../notify/event.const";
import { EventService } from "../../shared/event/event.service";
import { ManualQuote } from "../models/quote-manual.model";
import { WysiwygComponent } from "../../ui/wysiwyg/wysiwyg.component";

@Component({
  selector: "app-quote-terms",
  templateUrl: "./quote-terms.component.html",
  styleUrls: ["./quote-terms.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [WysiwygComponent],
})
export class QuoteTermsComponent implements OnInit, OnDestroy {
  private quoteRepository = inject(QuoteRepository);
  private eventService = inject(EventService);

  public quoteType = quoteType;
  public editorEnabled = false;
  public quoteTerms: QuoteTerms;
  public editableTerms = "";
  public termsChangeSubject = new Subject<string>();
  public readonly quote = input<Quote>(undefined);
  public readonly termsChange = output<string>();
  private subscription = new Subscription();

  ngOnInit() {
    this.fetchTerms();
    this.listenToEvents();
    this.observeWysiwygChanges();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public observeWysiwygChanges() {
    this.subscription.add(
      this.termsChangeSubject
        .pipe(distinctUntilChanged())
        .subscribe((customTerms) => {
          this.termsChange.emit(customTerms);
        }),
    );
  }

  public toggleEditor(enabled: boolean) {
    if (enabled === false) {
      this.editableTerms = this.quoteTerms.terms;
    }
    if (enabled !== this.editorEnabled) {
      this.editorEnabled = !this.editorEnabled;
      this.termsChange.emit(this.editorEnabled ? this.editableTerms : "");
    }
  }

  public fetchTerms() {
    this.subscription.add(
      this.quoteRepository.getTerms(this.quote().getId()).subscribe((terms) => {
        this.quoteTerms = terms;

        this.editableTerms =
          terms.customTerms !== null ? terms.customTerms : terms.terms;

        this.editorEnabled = terms.customTerms !== null ? true : false;
      }),
    );
  }

  public isShowToolbarItems() {
    return this.quote() instanceof FclTariff ? false : true;
  }

  public showModifyTermsAndConditions(): boolean {
    return this.quote().getClients().length === 1;
  }

  private listenToEvents() {
    // Only Manual Quote needs to be refreshed here
    if (this.quote() instanceof ManualQuote) {
      this.subscription.add(
        this.eventService.eventBus
          .pipe(debounceTime(1000))
          .subscribe((incoming) => {
            if (incoming.event === eventType.quoteUpdated) {
              this.fetchTerms();
            }
          }),
      );
    }
  }
}
